import React from 'react'
import styles from './EmbedViewer.scss'
import blockSizes from '../../../App/blockSizes.scss'

export const EmbedViewer = ({ block }) => {
  const data = block.getData()

  const src = data.get('src')
  const ratio = data.get('ratio')
  const height = data.get('height', 480)

  let dstyle = {}

  if (ratio) {
    dstyle[ 'paddingTop' ] = `${100 * ratio}%`
  } else {
    dstyle[ 'paddingTop' ] = `${height}px`
  }

  return (
    <div className={blockSizes.normalBlock}>
      <div className={styles.EmbedViewer} style={dstyle}>
        <iframe src={`${src}`} frameBorder='0' />
      </div>
    </div>
  )
}
